/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-mate.all-chat-view.chat-item.chat-options-button-label': 'Options de chat pour {conversationName}',
  'ai-mate.all-chat-view.chat-item.delete-label': 'Supprimer',
  'ai-mate.all-chat-view.chat-item.rename-label': 'Renommer',
  'ai-mate.chat-error-banner.description': "Votre historique de chat est conservé jusqu'à 30 jours.",
  'ai-mate.chat-error-banner.title': 'Démarrer un nouveau chat',
  'ai-mate.chat-error.description': 'Essayez de <btn>recharger le chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Vous avez atteint le nombre maximal de demandes. Veuillez réessayer ultérieurement.',
  'ai-mate.chat-error.rate-limited-title': 'Trop de demandes',
  'ai-mate.chat-error.rovo-inactive-description':
    "Il semble que Rovo n'est pas activé sur votre site. <link>Configurer Rovo</link>",
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo est inactif',
  'ai-mate.chat-error.title': "Nous ne savons pas ce qui s'est passé",
  'ai-mate.chat-input.file-close-icon-label': 'Supprimer le fichier',
  'ai-mate.chat-input.file-error-icon-label': 'Erreur de chargement du fichier',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Supprimer',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Options de chat pour {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Renommer',
  'ai-mate.common.ui.expandable-section.collapse': 'Réduire',
  'ai-mate.common.ui.expandable-section.expand': 'Développer',
  'ai-mate.conversation-assistant-page-selector.page-selector-label': 'Sélectionner la page',
  'ai-mate.conversation-assistant-space-selector.space-selector-label': "Sélectionner l'espace",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Annuler',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    "La conversation que vous essayez de supprimer n'existe pas.",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Supprimer',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Supprimer la conversation « {name} » ?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    "Une erreur s'est produite lors de la suppression de cette conversation. Veuillez réessayer.",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Voulez-vous vraiment supprimer cette conversation ? Cette action est irréversible.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Annuler',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    "Le canal que vous essayez de modifier n'existe pas.",
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Nom',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    "Une erreur s'est produite lors de la modification de cette conversation. Veuillez réessayer.",
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Modifier la conversation',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Le nom est le même que le nom actuel.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Enregistrer',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {{results,number} résultat trouvé} other {{results,number} résultats trouvés}}',
  'ai-mate.conversation-list-view.back-button.label': 'Retour',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Fermer le chat',
  'ai-mate.conversation-list-view.header-title': 'Historique du chat',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Nouveau chat',
  'ai-mate.conversation-list-view.no-chat': 'Aucun résultat',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Recherchez des chats',
  'ai-mate.expander.hide-details': 'Masquer les informations',
  'ai-mate.expander.show-details': "Afficher plus d'informations",
  'ai-mate.main-chat.close-chat-panel-button-label': 'Fermer le chat',
  'ai-mate.main-chat.hamburger-menu-label': 'Menu',
  'ai-mate.main-chat.maximize-chat-button-label': 'Plein écran',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restaurer la vue',
  'ai-mate.main-chat.new-chat-button-label': 'Nouveau',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nouveau chat',
  'ai-mate.rovo-chat-header.back-home-button-label': "Revenir à l'accueil",
  'ai-mate.rovo-chat-header.close-chat-header-button-label': 'Fermer',
  'ai-mate.rovo-chat-header.debug-button-label': 'Déboguer',
  'ai-mate.rovo-chat-header.debug-icon-label': 'Déboguer',
  'ai-mate.rovo-chat-header.delete-button-text': 'Supprimer',
  'ai-mate.rovo-chat-header.delete-icon-label': 'Supprimer',
  'ai-mate.rovo-chat-header.feedback-button-text': 'Commentaire',
  'ai-mate.rovo-chat-header.feedback-icon-label': 'Commentaire',
  'ai-mate.rovo-chat-header.floating-button-text': 'Flottant',
  'ai-mate.rovo-chat-header.floating-icon-label': 'Flottant',
  'ai-mate.rovo-chat-header.fullscreen-button-text': 'Plein écran',
  'ai-mate.rovo-chat-header.fullscreen-icon-label': 'Plein écran',
  'ai-mate.rovo-chat-header.get-help-button-text': "Obtenir de l'aide",
  'ai-mate.rovo-chat-header.get-help-icon-label': "Obtenir de l'aide",
  'ai-mate.rovo-chat-header.menu-button-label': 'Menu',
  'ai-mate.rovo-chat-header.more-menu-button-label': 'Plus',
  'ai-mate.rovo-chat-header.new-agent-chat-button-label': 'Nouveau chat avec {agentName}',
  'ai-mate.rovo-chat-header.new-chat-button-label': 'Nouveau chat',
  'ai-mate.rovo-chat-header.rename-button-text': 'Renommer',
  'ai-mate.rovo-chat-header.rename-icon-label': 'Renommer',
  'ai-mate.rovo-chat-header.sidebar-button-text': 'Volet latéral',
  'ai-mate.rovo-chat-header.sidebar-icon-label': 'Volet latéral',
  'ai-mate.rovo-chat-header.switch-mode-button-label': 'Changer',
  'ai-mate.rovo-chat-header.switch-mode-section-text': 'Changer',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'conversation-assistant-message-actions.require-information-tool.project-selector.header': 'Sélectionner un projet',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Envoyer',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Interroger Atlassian Intelligence à ce sujet',
  'highlight-actions.rovo-chat-explain-option.text': 'Expliquer',
  'highlight-actions.rovo-chat-explain-prompt':
    "Expliquez votre préférence en reformulant la phrase et en ajoutant des détails supplémentaires, mais utilisez un langage très simple, des phrases courtes, et donnez des exemples ou une définition à toute terminologie technique utilisée dans la formulation d'origine.",
  'highlight-actions.rovo-chat-find-resources-option.text': 'Rechercher des ressources',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Trouvez des ressources uniquement dans les connaissances organisationnelles qui valident les déclarations faites.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Donner des exemples',
  'highlight-actions.rovo-chat-give-examples-prompt':
    "Donnez-en des exemples tirés de ressources organisationnelles ou de connaissances publiques. Si vous n'avez aucune ressource à fournir, essayez de donner un exemple métaphorique qui pourrait aider quelqu'un à mieux comprendre les choses.",
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Envoyer un commentaire',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Commentez la formulation. Commentez le choix des mots, la grammaire et la ponctuation. Soyez positif et enthousiaste, mais suggérez toujours au moins un élément à améliorer ou à changer.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recommandations de Rovo Chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Ouvrir Rovo Chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Résumer',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Soulignez les points clés qui en découlent. Concentrez-vous sur les informations essentielles et excluez les informations inutiles. Donnez un aperçu concis en un seul paragraphe.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Demander dans le chat',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Poser une question à ce sujet.',
  'horizontal-scroll-container.scroll-left': 'Faire défiler vers la gauche',
  'horizontal-scroll-container.scroll-right': 'Faire défiler vers la droite',
  'rovo-chat.deep-research-spotlight.description':
    'Activez la recherche approfondie et saisissez un prompt. Rovo élaborera un plan, mènera les recherches et produira un rapport complet.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Ignorer',
  'rovo-chat.deep-research-spotlight.heading': 'Présentation de la recherche approfondie dans Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Glissez-déposez pour ajouter du contexte',
  'rovo-chat.message-file.icon-label': 'Fichier',
  'rovo-chat.rovo-greeting.deep-research-greeting-text': 'Allons plus loin',
  'rovo-chat.rovo-greeting.default-greeting-text': '{name}, comment puis-je vous aider ?',
  'rovo-chat.search-input.screen-reader-prompt':
    "La saisie de n'importe quel caractère dans ce champ mettra à jour les résultats de recherche ci-dessous",
};
